import React from "react";
import { Link } from "react-router-dom";
import "./style/Header.scss";
import logo from "../../assets/images/logo.png";

const Header = (props) => {
  const path = props.match.path;
  return (
    <React.Fragment>
      <nav className="header-navbar container-fluid fixed-top bg-white pb-2">
        <div className="site-logo">
          <img src={logo} alt="site logo" className="logo-image" />
        </div>
        <div className="nav-menu">
          <ul className="menu-container">
            <li className="menu-item">
              <Link
                to="/"
                className={props.match.path == "/" ? "active-link" : ""}
              >
                Home
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to="/movies"
                className={path == "/movies" ? "active-link" : ""}
              >
                Movies
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to="/tvshow"
                className={path == "/tvshow" ? "active-link" : ""}
              >
                Tv Series
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </React.Fragment>
  );
};

export default Header;
